import "bootstrap/dist/css/bootstrap.min.css";
import { LayoutPrincipal } from './Layout/LayoutPrincipal';
function App() {  
  return (
    <>    
      <LayoutPrincipal/>
    </>
  )
}

export default App;